import { FC } from 'react';
import { Stack } from '@mui/material';

const CreateJiraTicketFieldsGridWrapper: FC<
  React.PropsWithChildren<CreateJiraTicketFieldsWrapperProps>
> = ({ children }) => {
  return (
    <Stack
      gap={2}
      sx={theme => ({
        '& > div': {
          flexBasis: `calc(50% - ${theme.spacing(1)})`,
          flexGrow: 1,
          maxWidth: `calc(50% - ${theme.spacing(1)})`,
        },
      })}
      flexWrap='wrap'
      direction='row'>
      {children}
    </Stack>
  );
};

export interface CreateJiraTicketFieldsWrapperProps {}

export default CreateJiraTicketFieldsGridWrapper;
